import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IPricingObj {
  period: number;
  price: string;
}

export interface IBuySubscriptionPayload {
  type: string;
  period: number;
  price: number | string;
}

export interface ISubscriptionData {
  type: string;
  pricing: IPricingObj[];
}

export interface ISubscriptionsState {
  subscriptionsList: ISubscriptionData[] | null;
}

const initialState: ISubscriptionsState = {
  subscriptionsList: null,
};

const subscriptionSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    fetchSubscriptionsList: () => {},
    fetchBuySubscription: (state, action: PayloadAction<any>) => ({
      ...state,
      payload: action.payload,
    }),
    fetchCancelAutoRenewalOfSubscription: () => {},
    setSubscriptionsList: (
      state,
      action: PayloadAction<ISubscriptionData[] | null>
    ) => ({
      ...state,
      subscriptionsList: action.payload,
    }),
  },
});

export const subscriptionReducer = subscriptionSlice.reducer;
export const subscriptionActions = subscriptionSlice.actions;
